import React from "react";
import ArrayErrorField from "./ArrayErrorField";

const FileUploads = (props) => {

    const fileList = props.values[props.name.split(".")[0]][props.name.split(".")[1]];

    const addFile = (event) => {
        event.preventDefault();

        fileList.push(event.currentTarget.files[0]);
        props.setFieldValue("files", fileList, true);
    }

    return (
        <>
        <div className="form-group">
            <input id="file1" name={`${props.name}[0]`} type="file" onChange={addFile} className="form-control" />
            <input id="file2" name={`${props.name}[1]`} type="file" onChange={addFile} className="form-control" />
            <input id="file3" name={`${props.name}[2]`} type="file" onChange={addFile} className="form-control" />
            <input id="file4" name={`${props.name}[3]`} type="file" onChange={addFile} className="form-control" />
        </div>

        <ArrayErrorField {...props}></ArrayErrorField>
        </>
    )
}

export default FileUploads;